import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';
import { copyToClipboard } from '#src/app/shared/utils/clipboard';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

// eslint-disable-next-line max-params
export function shareLine(
	url: string,
	text: string | undefined,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
	i18nContext: UtilityContext['i18n'],
): void {
	// Message pre-population might not work on Android from a Facebook Web View, so the link also
	// goes to the clipboard as a fallback (CHANGE-84268).
	//
	// Trigger and forget — awaiting here would give up the tap's user activation that iOS wants
	// before it hands the scheme to the OS. Nothing reads the result.
	void copyToClipboard(url, i18nContext);
	const msg = encodeURIComponent(text ? `${text}\n${url}` : url);
	openUrlWithHiddenAnchor(`line://msg/text/${msg}`);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
